import { captureStore } from '@playcastdotio/InputCapture';

import {
  PlaycastMessage,
  PlaycastMessagePlayerSetInputAccess,
  PlaycastMessageStateReplication,
  PlaycastMessageTarget,
  PlaycastPlayerMessages,
  PlaycastStateMessages,
} from '@playcastdotio/Messaging';
import * as stores from '../../stores/playerStores';

export const handleHostMessage = (data: PlaycastMessage<PlaycastMessageTarget>): void => {
  const { target } = data.header;
  if (target === 'state') {
    const stateMsg = data as PlaycastMessage<PlaycastStateMessages>;
    switch (stateMsg.header.action) {
      case 'replication': {
        const validatedMessage = stateMsg as PlaycastMessage<PlaycastMessageStateReplication<keyof typeof stores>>;
        const channel = validatedMessage.body.message.channel;
        if (stores[channel]) {
          if ('updateState' in stores[channel]) {
            stores[channel].updateState(validatedMessage.body.message.state as any);
          } else {
            console.error('Invalid channel:', channel);
          }
        } else {
          console.error('Invalid channel:', channel);
        }
      }
    }
  }
  if (target === 'player') {
    const playerMsg = data as PlaycastMessage<PlaycastPlayerMessages>;
    const action = playerMsg.header.action;
    switch (action) {
      case 'setInputAccess': {
        const message = (playerMsg as PlaycastMessage<PlaycastMessagePlayerSetInputAccess>).body.message;
        captureStore.updateAccess({
          mouse: message.access.mouse,
          keyboard: message.access.keyboard,
          touch: message.access.touch,
          gamepad: message.access.gamepad,
        });
        return;
      }
    }
  }
};
